import React from "react";
import cx from "classnames";
import styles from "./Style.module.scss";
import {
  Row,
  Col,
  FormGroup,
  InputGroup,
  FormControl,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import _ from "lodash";
import { localizedStrings } from '../../../../../../localization';

class ListDetailView extends React.Component {
  constructor(props) {
    super(props);

    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedCustomFields = this.localizedSettings.account.custom_fields;
  }

  _handleChange(option, e) {
    option.value = e.target.value;
    this.props.onChange(option);
  }

  render() {
    return (
      <FormGroup className={styles.formGroup}>
        <InputGroup>
          <FormControl
            type="text"
            placeholder=""
            value={this.props.option.value}
            onChange={this._handleChange.bind(this, this.props.option)}
            disabled={!_.isEmpty(this.props.integrationType)}
          />

          {_.isEmpty(this.props.integrationType) && (
            <InputGroup.Text className={styles.delete}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="addMenuTooltip">{this.localizedCustomFields.delete_option}</Tooltip>
                }
              >
                <div
                  className={styles.action}
                  onClick={() => this.props.onDelete(this.props.option)}
                >
                  <i className="paperflite-delete"></i>
                </div>
              </OverlayTrigger>
            </InputGroup.Text>
          )}
        </InputGroup>
      </FormGroup>
    );
  }
}

export default ListDetailView;
